// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + "moduleEind" + "." + "71b9b7a2" + ".css";
};